// extracted by mini-css-extract-plugin
module.exports = {"shareIcon":"share-module--shareIcon--1q9gi"};